import { action, computed, makeObservable, observable } from 'mobx'

import type ExtendedMap from '@/models/ExtendedMap'

import { EMPTY_NUMBER_ID } from '@/constant/common'
import type { AcademyNotice, Faq, Qna } from '.'

type NoticeTypes = Faq | AcademyNotice | Qna

export class NoticeColl<T extends NoticeTypes> {
  constructor(private NoticeMap: ExtendedMap<T['id'], T>) {
    makeObservable<NoticeColl<T>, '_selectedId'>(this, {
      _selectedId: observable,
      selectedId: computed,
      toArr: computed,
      select: action,
      isEmpty: computed,
    })
  }

  private _selectedId?: T['id'] = EMPTY_NUMBER_ID

  get selectedId() {
    return this._selectedId
  }

  get toArr() {
    return [...this.NoticeMap.values()]
  }

  get isEmpty() {
    return this.NoticeMap.isEmpty
  }

  select = (id: T['id']) => {
    if (this.selectedId === id) {
      this._selectedId = undefined
      return
    }
    this._selectedId = id
  }

  adds(noticeColl: NoticeColl<T>) {
    this.NoticeMap.adds(noticeColl.NoticeMap.entries())
  }
}
